import React from 'react';
import ServicesMain from '../ServicesMain/ServicesMain';

const Services = () => {
    return (
        <div>
            <ServicesMain />
        </div>
    );
};

export default Services;